import { cva } from 'class-variance-authority';

const inputErrorStylesSAG = cva([
  'dark:text-[#FF7687]',
  'text-[#B81E31]',
  'text-xs',
  'select-none',
  'mt-1',
]);

const inputErrorStylesSHS = cva([
  'dark:text-[#e7001e]',
  'text-[#e7001e]',
  'text-xs',
  'select-none',
  'mt-1',
]);

export { inputErrorStylesSAG, inputErrorStylesSHS };
